import { render, staticRenderFns } from "./ReplaceComponent.vue?vue&type=template&id=c80841d8&scoped=true&"
import script from "./ReplaceComponent.vue?vue&type=script&lang=js&"
export * from "./ReplaceComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceComponent.vue?vue&type=style&index=0&id=c80841d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80841d8",
  null
  
)

export default component.exports